export default __webpack_public_path__ + "static/media/9.d56e1a38.jpg";